import script from "./SignaturePadField.vue?vue&type=script&lang=ts&setup=true"
export * from "./SignaturePadField.vue?vue&type=script&lang=ts&setup=true"

import "./SignaturePadField.vue?vue&type=style&index=0&id=b70fa276&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b70fa276"]])

export default __exports__